import { render } from "./MandatoryCourseTrack.vue?vue&type=template&id=4e893459&scoped=true&ts=true"
import script from "./MandatoryCourseTrack.vue?vue&type=script&lang=ts"
export * from "./MandatoryCourseTrack.vue?vue&type=script&lang=ts"

import "./MandatoryCourseTrack.vue?vue&type=style&index=0&id=4e893459&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e893459"]])

export default __exports__